import { useEffect } from "react";

const DraftConfirmationPopup = ({
  open,
  close,
  confirm,
  title = "Make this document a draft?",
  description = "Users will not be able to reach this information until you activate it again",
  /** Optional bullet list shown under the description (e.g. unsaved or pending fields). */
  detailItems = null,
  confirmText = "Confirm",
  cancelText = "Cancel",
  cancelVariant = "cancel",
  confirmVariant = "confirm",
  confirmDisabled = false,
  /** Optional class on the fixed layer root (e.g. lesson editor–scoped styling in editLesson.css). */
  layerClassName = "",
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        close?.();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, close]);

  if (!open) return null;

  return (
    <div
      className={`pd-draft-modal-layer${layerClassName ? ` ${layerClassName}` : ""}`}
      role="presentation"
    >
      <div className="pd-draft-modal-backdrop" onClick={close} />
      <div
        className="pd-draft-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="pd-draft-modal-title"
        aria-describedby="pd-draft-modal-description"
      >
        <h2 id="pd-draft-modal-title" className="pd-draft-modal-title">
          {title}
        </h2>
        <p id="pd-draft-modal-description" className="pd-draft-modal-description">
          {description}
        </p>
        {Array.isArray(detailItems) && detailItems.length > 0 ? (
          <ul className="pd-draft-modal-detail-list" aria-label="Details">
            {detailItems.map((line, idx) => (
              <li key={`${idx}-${line}`}>{line}</li>
            ))}
          </ul>
        ) : null}
        <div className="pd-draft-modal-actions">
          <button
            type="button"
            className={`pd-draft-modal-btn ${cancelVariant}`}
            onClick={close}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className={`pd-draft-modal-btn ${confirmVariant}`}
            onClick={confirm}
            disabled={confirmDisabled}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraftConfirmationPopup;
